
import { Link, useParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { Module, Lesson } from "@/lib/types";
import { useTranslation } from 'react-i18next';

interface CourseContentListProps {
  modules: Module[];
  lessons: Record<string, Lesson[]>;
  hasAccess: boolean;
}

export function CourseContentList({ modules, lessons, hasAccess }: CourseContentListProps) {
  const { slug = "" } = useParams<{ slug: string }>();
  const courseSlug = slug;
  const { t } = useTranslation();
  return (
    <div className="bg-card rounded-lg shadow-md overflow-hidden mt-6">
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-6">{t('courseContent')}</h2>
        
        {modules.length === 0 ? (
          <p className="text-muted-foreground">No content available yet.</p>
        ) : (
          <div className="space-y-6">
            {modules
              .sort((a, b) => a.position - b.position)
              .map((module) => (
                <div key={module.id} className="border-b border-border pb-4 last:border-0 last:pb-0">
                  <h3 className="text-xl font-semibold mb-4">{module.title}</h3>
                  <ul className="space-y-3">
                    {module.lessons
                      .sort((a, b) => a.position - b.position)
                      .map((lesson) => (
                        <li key={lesson.slug}>
                          {hasAccess ? (
                            <Link
                              to={`/courses/${courseSlug}/${module.id}/${lesson.slug}`}
                              className="flex items-center justify-between p-3 rounded-md hover:bg-muted"
                            >
                              <span>{lesson.title}</span>
                              <span className="text-primary">→</span>
                            </Link>
                          ) : (
                            <div className="flex items-center justify-between p-3 rounded-md text-muted-foreground">
                              <span>{lesson.title}</span>
                              <Lock className="h-4 w-4" />
                            </div>
                          )}
                        </li>
                    ))}
                  </ul>
                </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
